export default __webpack_public_path__ + "static/media/MT2_activations_XY.77a9294c.png";